import styled from 'styled-components';
import { mixins } from '../../styles';

export const LayoutStyled = styled.div`
  ${mixins.contentWide};
`;
